import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BrowserModule } from '@angular/platform-browser';
import { GenesysTransferPanelComponent } from './genesys-transfer-panel.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { ReactiveFormsModule } from '@angular/forms';
import { LoadingModule } from '../loading/loading.module';
import { GenesysTransferPanelSearchComponent } from './genesys-transfer-panel-search/genesys-transfer-panel-search.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { GenesysTransferPanelSearchListComponent } from './genesys-transfer-panel-search/genesys-transfer-panel-search-list/genesys-transfer-panel-search-list.component';

@NgModule({
  declarations: [
    GenesysTransferPanelComponent,
    GenesysTransferPanelSearchComponent,
    GenesysTransferPanelSearchListComponent
  ],
  exports: [
    GenesysTransferPanelComponent
  ],
  imports: [
    BrowserModule,
    TranslateModule.forChild(),
    SvgIconModule,
    ReactiveFormsModule,
    CommonModule,
    LoadingModule,
    ScrollingModule
  ]
})
export class GenesysTransferPanelModule { }
